import React from 'react';

type MyBookingsSkeletonProps = {
  variant?: 'desktop' | 'mobile';
};

const BookingCardSkeleton: React.FC = () => (
  <div className="border border-[#E9E9E9] rounded-xl p-4 bg-white relative overflow-hidden">
    <div className="absolute inset-0 w-full h-full animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent z-10 pointer-events-none" />
    <div className="h-32 bg-gray-200/70 rounded-lg mb-3 animate-pulse" />
    <div className="h-5 bg-gray-200/70 rounded w-3/4 mb-2 animate-pulse" />
    <div className="h-3 bg-gray-200/70 rounded w-1/2 animate-pulse" />
  </div>
);

const MyBookingsSkeleton: React.FC<MyBookingsSkeletonProps> = ({ variant = 'desktop' }) => {
  const isDesktop = variant === 'desktop';

  return (
    <div
      role="status"
      aria-label="Loading bookings"
      className="w-full font-open-sans bg-[#fff] min-h-screen relative overflow-hidden"
    >
      <div className={`mx-auto ${isDesktop ? 'w-10/12 sm:w-[1200px]' : 'w-full px-4'} py-10`}>
        <div className="h-4 bg-gray-200/70 rounded w-24 mb-6 animate-pulse" />
        <div className={`h-8 bg-gray-200/70 rounded animate-pulse mb-6 ${isDesktop ? 'w-80' : 'w-64'}`} />
        <div className="flex flex-wrap gap-3 mb-6">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="h-9 bg-gray-200/70 rounded-lg w-24 animate-pulse" />
          ))}
        </div>
        <div
          className={`grid gap-6 ${
            isDesktop ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3' : 'grid-cols-1'
          }`}
        >
          {Array.from({ length: isDesktop ? 6 : 4 }).map((_, index) => (
            <BookingCardSkeleton key={index} />
          ))}
        </div>
      </div>
      <span className="sr-only">Loading bookings...</span>
    </div>
  );
};

export default MyBookingsSkeleton;
